module.exports = __webpack_public_path__ + "img/style1.f533a4d9.png";